// @ts-nocheck
import { Plugin } from '/Users/zhaoxiangyang/home/jwm_projects_code/拓界化工厂巡检-邓文奇/MaYun.UI/node_modules/umi/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','locale','request',],
});

export { plugin };
